// extracted by mini-css-extract-plugin
module.exports = {"root":"Navigation_root__5-RED","list":"Navigation_list__2ZMOY","drawerRoot":"Navigation_drawerRoot__2sgH7","drawerList":"Navigation_drawerList__1PhGb"};